//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import Footer from '../components/footer.vue'
  import {
    SaunaWarningQuery
  } from '../../static/js/api.js'


function toTime(strTime) {
    if (!strTime) {
        return '';
    }
 
    //如果有“Z”, 直接用new Date()转换 
    if (strTime.indexOf("Z") > 0){
        return (new Date(strTime));
    }
 
    var myDate = new Date(strTime + '+0800');
    if (myDate == 'Invalid Date') {
        strTime = strTime.replace(/T/g, ' '); //去掉T
        strTime = strTime.replace(/-/g, '/');
        strTime = strTime.replace(/\.\d+/, ' ');//去掉毫秒
        myDate = new Date(strTime + '+0800');       
    }    
 
    return myDate;
}
  function loadtotal(that) {



      SaunaWarningQuery({StrStartDate: that.value1+" 00:00:00", StrEndDate: that.value2+" 23:59:59"}, function (res) {
          console.log(res)
          if (res.data.IsSuccess) {
              var oldData=JSON.parse(res.data.Result)
           
              that.data = oldData
              that.loading=false
              
              
              console.log(that.data)

              that.tuidan = res.data.tuidan? res.data.tuidan.split("，") : []
              console.log(that.tuidan)



              var newArrs = JSON.parse(res.data.Result).BackConsumes
             
              var selectArr = []
              if(that.tuidan.length!=0){
                
               
                
                for(var j = 0 ;j<newArrs.length;j++){
                   for(var i=0;i<that.tuidan.length;i++){
                    var item  = that.tuidan[i]
                    if(item == newArrs[j].CatalogueCode){
                      selectArr.push(newArrs[j]);
                      break
                    }

                }
               


                
              }
              selectArr = selectArr.concat(newArrs.filter((item)=> !selectArr.includes(item) ))
              }else{
                for(var j = 0 ;j<newArrs.length;j++){
                 
                    selectArr.push(newArrs[j])
                }
                
              }
              

              console.log(selectArr);

             that.forArr = selectArr





          } else {

              that.$vux.toast.text('数据获取失败，请重试', 'middle')

          }


      })

  }

  export default {
    name: 'app',
    components: {
      'pc-footer': Footer,
    },
    data() {
      return {

        loading:true,
        tuidan:[],
        forArr:[],
        data: {
          BackConsumes: {},
          GivingConsumes: {},
          DeratePayDetails: {},
          OverHandCards: {},
          Backbills:{}

        },
        value1: '',
        value2: '',
        msg: 'Welcome to Your Vue.js App',
        showContent001: false,
        showContent002: false,
        showContent003: false,
        showContent004: false,
        showContent005: false,
        showContent006: false,
        showContent007: false,
        showContent008: false,
          selected:1,

          nav:[
              {
                  id:1,
                  name:"退单"

              },
              {
                  id:2,
                  name:"赠送"

              },
              {
                  id:3,
                  name:"免单"

              },{
                  id:4,
                  name:"小时未结"

              },{
                  id:5,
                  name:"反结账"

              }


          ],
      }
    },
    created() {
      var that = this
      console.log('ccc' + that.value1);



        var dates=new Date()
        var years = dates.getFullYear()//当前年
        var months = (dates.getMonth() + 1) <10? "0" + ((dates.getMonth() + 1) + '') : (dates.getMonth() + 1) //当前月份

        var days = dates.getDate()<10?"0" + (dates.getDate()+"") :dates.getDate() //当天


        var d = new Date();
        d.setDate(d.getDate() - 1);
        var yy1 = d.getFullYear();
        var mm1 = d.getMonth() + 1;//因为getMonth（）返回值是 0（一月） 到 11（十二月） 之间的一个整数。所以要给其加1
        var dd1 = d.getDate();
        if (mm1 < 10) {
            mm1 = '0' + mm1;
        }
        if (dd1 < 10) {
            dd1 = '0' + dd1;
        }
        that.value2=yy1+'-'+mm1+'-'+dd1
        that.value1=yy1+'-'+mm1+'-'+dd1



        loadtotal(that)






    },
    methods: {

      onConfirm1(val) {
        this.value1 = val

      },
      onConfirm2(val) {
        this.value2 = val
      },
      refresh(){
          this.loading=true
          var that=this
          loadtotal(that)


      },
      change(index){
          console.log(index)
          this.selected= parseInt(index+1)

      },
      search() {
        console.log('77777777777777');
        var that = this
        var data = {
          StrStartDate: that.value1,
          StrEndDate: that.value2
        };
          this.loading=true
         loadtotal(that)

      },
      dateFormat:function(time) {
        var date=toTime(time);
        console.log(date)
        var year=date.getFullYear();
        /* 在日期格式中，月份是从0开始的，因此要加0
         * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
         * */
        var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
        var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
        var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
        var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
        var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
        // 拼接
        return month+"-"+day+" "+hours+":"+minutes;
      }
    }
  }



// WEBPACK FOOTER //
// ./src/pages/yichang.vue